import { t } from '@lingui/core/macro';
import { ButtonGroup } from '@pocketlaw/tetris';
import { ClearFilter } from './components/ClearFilter';
import { NullOperator } from './components/NullOperator';
import { OperatorSelector } from './components/OperatorSelector';
import { SingleSelectOperator } from './components/SingleSelectOperator';
import { useFilter } from './useFilter';
export function BooleanFilter(props) {
    const { name, label } = props;
    const filter = useFilter(name);
    const items = [
        {
            id: 'true',
            value: true,
            title: t({ message: 'Yes', comment: 'Insights: Boolean filter - yes' }),
        },
        {
            id: 'false',
            value: false,
            title: t({ message: 'No', comment: 'Insights: Boolean filter - yes' }),
        },
    ];
    return (<ButtonGroup>
      <OperatorSelector label={label} name={name} operators={[
            {
                id: 'eq',
                menuItem: t({ message: 'Equals', comment: 'Search: Filter operator - is' }),
                label: t({ message: 'equals', comment: 'Search: Filter operator - is' }),
                onSelect: () => filter.applyValue({ eq: undefined }),
            },
            {
                id: 'isNull',
                menuItem: t({ message: 'Has value', comment: 'Search: Filter operator - has value' }),
                label: t({ message: 'has', comment: 'Search: Filter operator - has value' }),
                onSelect: () => filter.applyValue({ isNull: undefined }),
            },
        ]}/>

      {filter.operator === 'eq' && <SingleSelectOperator name={name} items={items}/>}

      {filter.operator === 'isNull' && <NullOperator name={name}/>}

      <ClearFilter name={name}/>
    </ButtonGroup>);
}
